/* eslint-disable no-undef */
import * as Sentry from '@sentry/browser';
import { env } from '~/env';

// should have been called before using it here
// ideally before even rendering your react app
if (env.shouldSendMetrics) {
    Sentry.init({
        dsn: env.runtimeConfig.sentryToken,
        environment: env.isRunningOnProd ? 'production' : 'test',
        // Ignore common non-actionable errors
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications',
        ],
    });
}

export const reportErrorToSentry = (error, {
    tags,
    user,
    extra,
    context,
    level,
    fingerprint,
} = {}) => {
    const exception = error instanceof Error ? error : new Error(String(error));

    return Sentry.withScope(scope => {
        if (tags) {
            scope.setTags(tags);
        }
        if (user) {
            scope.setUser(user);
        }
        if (level) {
            scope.setLevel(level);
        }
        if (fingerprint) {
            scope.setFingerprint(fingerprint);
        }
        if (extra) {
            Object.entries(extra).forEach(([key, value]) => {
                scope.setExtra(key, value);
            });
        }
        if (context) {
            Object.entries(context).forEach(([key, value]) => {
                scope.setContext(key, value);
            });
        }
        return Sentry.captureException(exception);
    });
};
